import { render, staticRenderFns } from "./BorderBox.vue?vue&type=template&id=651a0b2b&scoped=true&"
import script from "./BorderBox.vue?vue&type=script&lang=ts&"
export * from "./BorderBox.vue?vue&type=script&lang=ts&"
import style0 from "./BorderBox.vue?vue&type=style&index=0&id=651a0b2b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651a0b2b",
  null
  
)

export default component.exports